import { Route } from '@angular/router';
import { AuthenticatedGuard } from '../guards/authenticated.guard';

export const appRoutes: Route[] = [
    {
        path: '',
        redirectTo: 'orders',
        pathMatch: 'full', // Ensures the entire URL matches before redirecting
    },
    {
        path: '',
        canActivate: [AuthenticatedGuard],
        loadComponent: () => import('../containers/home/home-container.component').then(m => m.HomeContainerComponent),
        children: [
            {
                path: 'orders',
                loadComponent: () =>
                    import('../containers/orders-list/orders-list-container.component').then(
                        m => m.OrdersListContainerComponent,
                    ),
            },
            {
                path: 'orders/:id',
                loadComponent: () =>
                    import('../containers/view-order/view-order-container.component').then(
                        m => m.ViewOrderContainerComponent,
                    ),
            },
            {
                path: 'products',
                loadComponent: () =>
                    import('../containers/products-list/products-list-container.component').then(
                        m => m.ProductListContainerComponent,
                    ),
            },
            {
                path: 'products/:id',
                loadComponent: () =>
                    import('../containers/edit-product/edit-product-container.component').then(
                        m => m.EditProductContainerComponent,
                    ),
            },
            {
                path: 'settings',
                loadComponent: () =>
                    import('../containers/settings/settings-container.component').then(
                        m => m.SettingsContainerComponent,
                    ),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'order',
        pathMatch: 'full',
    },
];

